import React from "react"

function IconDialpad({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="dialpad"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-dialpad"
      {...props}
    >
      <path
        d="M12.251 15.83a2.675 2.675 0 0 1 0 5.348 2.675 2.675 0 0 1 0-5.348zm0 1.309a1.366 1.366 0 1 0 .003 2.731 1.366 1.366 0 0 0-.003-2.731zM6.02 9.599a2.674 2.674 0 1 1-.001 5.349A2.674 2.674 0 0 1 6.019 9.6zm6.232 0a2.675 2.675 0 0 1 0 5.348 2.675 2.675 0 0 1 0-5.347zm6.253 0a2.675 2.675 0 0 1 0 5.348 2.675 2.675 0 0 1 0-5.347zM6.019 10.91a1.365 1.365 0 1 0 .002 2.73 1.365 1.365 0 0 0-.002-2.73zm6.232 0a1.366 1.366 0 1 0 .003 2.731 1.366 1.366 0 0 0-.003-2.731zm6.253 0a1.366 1.366 0 1 0 .003 2.731 1.366 1.366 0 0 0-.003-2.731zM6.019 3.346a2.673 2.673 0 1 1 0 5.346 2.673 2.673 0 0 1 0-5.346zm6.232 0a2.674 2.674 0 1 1 0 5.348 2.674 2.674 0 0 1 0-5.348zm6.253 0a2.674 2.674 0 1 1 0 5.348 2.674 2.674 0 0 1 0-5.348zM6.019 4.655a1.364 1.364 0 1 0 0 2.728 1.364 1.364 0 0 0 0-2.728zm6.232 0a1.365 1.365 0 1 0 .001 2.73 1.365 1.365 0 0 0 0-2.73zm6.253 0a1.365 1.365 0 1 0 0 2.73 1.365 1.365 0 0 0 0-2.73z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconDialpad
